// external dependencies
import React from 'react'
import styled from '@emotion/styled'
import { string } from 'prop-types'
import { Link } from '@jelly/ui'

// styled components
const ItemWrap = styled.div`
	line-height: normal;
`

const ItemLink = styled(Link)`
	text-decoration: none;
`

const ItemContainer = styled.div`
	display: inline-flex;
`

const Item = styled.div`
	display: inline;
`

const Title = styled.div`
	color: ${({ theme }) => theme.colors.text};
	font-size: 0.875rem;
	font-weight: 600;
	line-height: 1.25;
`

const Subtitle = styled.div`
	color: ${({ theme }) => theme.colors.text};
	font-size: 0.875rem;
	padding-top: 5px;
`

const DisplayUrl = styled.div`
	color: ${({ theme }) => theme.colors.contentLink};
	font-size: 0.875rem;
	padding-top: 3px;
`

const propTypes = {
	displayUrl: string,
	subtitle: string,
	title: string.isRequired,
	url: string,
}

function AdditionalItem({ displayUrl, subtitle, title, url }) {
	return (
		<ItemWrap>
			<ItemLink href={url}>
				<ItemContainer>
					<Item>
						<Title>{title}</Title>
						{subtitle && <Subtitle>{subtitle}</Subtitle>}
						{displayUrl && <DisplayUrl>{displayUrl}</DisplayUrl>}
					</Item>
				</ItemContainer>
			</ItemLink>
		</ItemWrap>
	)
}

AdditionalItem.propTypes = propTypes

export default AdditionalItem
